import { render, staticRenderFns } from "./DynamicView.vue?vue&type=template&id=7a310d94&scoped=true&"
import script from "./DynamicView.vue?vue&type=script&lang=js&"
export * from "./DynamicView.vue?vue&type=script&lang=js&"
import style0 from "./DynamicView.vue?vue&type=style&index=0&id=7a310d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a310d94",
  null
  
)

export default component.exports